import { Link2, Linkedin, Facebook, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";

const XIcon = (p) => (<svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M18.9 2H22l-7.3 8.3L23 22h-6.6l-5.2-6.8L5.3 22H2.2l7.8-8.9L1.5 2h6.7l4.7 6.2zm-1.1 18h1.7L7.3 3.9H5.5z" /></svg>);

export default function ShareButtons({ title }) {
  const { t } = useI18n();
  const url = window.location.href;
  const u = encodeURIComponent(url);
  const txt = encodeURIComponent(title);
  const links = [
    ["whatsapp", MessageCircle, `https://wa.me/?text=${txt}%20${u}`],
    ["x", XIcon, `https://twitter.com/intent/tweet?text=${txt}&url=${u}`],
    ["linkedin", Linkedin, `https://www.linkedin.com/sharing/share-offsite/?url=${u}`],
    ["facebook", Facebook, `https://www.facebook.com/sharer/sharer.php?u=${u}`],
  ];
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); } catch {
      const ta = document.createElement("textarea"); ta.value = url; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    toast.success(t("property.copied"));
  };
  const cls = "flex h-10 w-10 items-center justify-center rounded-full border border-fg/15 text-fg/70 transition-colors hover:border-cta hover:text-cta";
  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="me-2 text-xs uppercase tracking-wider text-fg/50">{t("property.share")}</span>
      <button type="button" onClick={copy} data-testid="share-copy-link" aria-label={t("property.copyLink")} className={cls}><Link2 className="h-4 w-4" /></button>
      {links.map(([k, Icon, href]) => (
        <a key={k} href={href} target="_blank" rel="noopener noreferrer" data-testid={`share-${k}`} aria-label={k} className={cls}><Icon className="h-4 w-4" /></a>
      ))}
    </div>
  );
}
